import { Properties } from "@/services/posts/types";
import { CSS } from "@/services/styles/types";

export interface DatePostProperties extends Properties {
    language: string;
    format: string;
    dateFormat: MomentFormat;
    showTime: number;
    timeZone:string
}

export interface Format {
    text: string;
    value: FormatValue;
}

export interface FormatValue {
    format: string;
    capitalize: CapitalizeEnum
}

export interface DateStyle extends CSS {
    date: string;
}

export enum CapitalizeEnum {
    FirtLetterCapital = "FirstLetterCapital",
    LowerCase = "LowerCase",
    Locale = "Locale"
}

export interface MomentFormat {
    textOne: string;
    textTwo: string;
    textThree: string;
    textFour: string;
    textFive: string;
    dateOptionOne: FormatValue;
    dateOptionTwo: FormatValue;
    dateOptionThree: FormatValue;
    dateOptionFour: FormatValue;
}

export const FormatOptions = [
    {
        text: "none",
        value: {
            format: "",
            capitalize: CapitalizeEnum.Locale
        }
    },
    {
        text: "d",
        value: {
            format: "D",
            capitalize: CapitalizeEnum.Locale
        }
    },
    {
        text: "dd",
        value: {
            format: "DD",
            capitalize: CapitalizeEnum.Locale
        }
    },
    {
        text: "m",
        value: {
            format: "M",
            capitalize: CapitalizeEnum.Locale
        }
    },
    {
        text: "mm",
        value: {
            format: "MM",
            capitalize: CapitalizeEnum.Locale
        }
    },
    {
        text: "yy",
        value: {
            format: "YY",
            capitalize: CapitalizeEnum.Locale
        }
    },
    {
        text: "yyyy",
        value: {
            format: "YYYY",
            capitalize: CapitalizeEnum.Locale
        }
    },
    {
        text: "month",
        value: {
            format: "MMMM",
            capitalize: CapitalizeEnum.LowerCase
        }
    },
    {
        text: "Month",
        value: {
            format: "MMMM",
            capitalize: CapitalizeEnum.FirtLetterCapital
        }
    },
    {
        text: "month short",
        value: {
            format: "MMM",
            capitalize: CapitalizeEnum.LowerCase
        }
    },
    {
        text: "Month short",
        value: {
            format: "MMM",
            capitalize: CapitalizeEnum.FirtLetterCapital
        }
    },
    {
        text: "day",
        value: {
            format: "dddd",
            capitalize: CapitalizeEnum.LowerCase
        }
    },
    {
        text: "Day",
        value: {
            format: "dddd",
            capitalize: CapitalizeEnum.FirtLetterCapital
        }
    },
    {
        text: "day short",
        value: {
            format: "ddd",
            capitalize: CapitalizeEnum.LowerCase
        }
    },
    {
        text: "Day short",
        value: {
            format: "ddd",
            capitalize: CapitalizeEnum.FirtLetterCapital
        }
    }
] as Array<Format>;

// languages
export const Languages = [
    {
        text: "english",
        code: "en"
    },
    {
        text: "danish",
        code: "da"
    },
    {
        text: "german",
        code: "de"
    },
    {
        text: "swedish",
        code: "sv"
    },
    {
        text: "norwegian",
        code: "nb"
    },
    {
        text: "finnish",
        code: "fi"
    },
    {
        text: "french",
        code: "fr"
    },
    {
        text: "greenland",
        code: "kl"
    },
    {
        text: "welsh",
        code: "cy"
    },
    {
        text: "dutch",
        code: "nl"
    },
    {
        text: "mexican",
        code: "es"
    }
];

// date format
export const DateFormats = [
    {
        text: "custom",
        value: "custom"
    },
    {
        text: "englishBritish",
        value: "e-b"
    },
    {
        text: "englishUS",
        value: "e-us"
    },
    {
        text: "danish",
        value: "dk"
    },
    {
        text: "swedish",
        value: "swed"
    },
    {
        text: "norweigan",
        value: "nor"
    },
    {
        text: "german",
        value: "ger"
    },
    {
        text: "french",
        value: "fr"
    }
];
